import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';

export const useSendPhoneVerificationCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      userService.sendPhoneCode(payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.user.phone_verify] });
          return data;
        }
        return null;
      }),
  });
};
